const protectedShortcutKeys = new Set(['a', 'c', 'i', 'j', 'p', 's', 'u', 'x']);
const listenerOptions = { capture: true, passive: false };

const isEditableElement = (target) => {
  if (!(target instanceof Element)) {
    return false;
  }

  return Boolean(
    target.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""]')
  );
};

export const enableContentProtection = () => {
  if (typeof window === 'undefined' || window.__seataskContentProtectionEnabled) {
    return;
  }

  window.__seataskContentProtectionEnabled = true;

  const blockEvent = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();
    return false;
  };

  const protectImages = () => {
    document.querySelectorAll('img').forEach((image) => {
      image.setAttribute('draggable', 'false');
      image.setAttribute('oncontextmenu', 'return false;');
      image.setAttribute('onselectstart', 'return false;');
    });
  };

  [window, document, document.documentElement, document.body].filter(Boolean).forEach((target) => {
    target.addEventListener('contextmenu', blockEvent, listenerOptions);
    target.addEventListener('dragstart', blockEvent, listenerOptions);
    target.addEventListener('mousedown', (event) => {
      if (event.button === 2) {
        blockEvent(event);
      }
    }, listenerOptions);
    target.addEventListener('auxclick', blockEvent, listenerOptions);
  });

  document.addEventListener('selectstart', (event) => {
    if (!isEditableElement(event.target)) {
      blockEvent(event);
    }
  }, listenerOptions);

  document.addEventListener('copy', (event) => {
    blockEvent(event);
    if (event.clipboardData) {
      event.clipboardData.setData('text/plain', '');
    }
  }, listenerOptions);

  document.addEventListener('cut', (event) => {
    blockEvent(event);
    if (event.clipboardData) {
      event.clipboardData.setData('text/plain', '');
    }
  }, listenerOptions);

  document.addEventListener('keydown', (event) => {
    const key = event.key.toLowerCase();
    const isProtectedShortcut = (event.ctrlKey || event.metaKey) && protectedShortcutKeys.has(key);
    const isDevtoolsShortcut =
      event.key === 'F12' ||
      ((event.ctrlKey || event.metaKey) && event.shiftKey && ['c', 'i', 'j'].includes(key));

    if (isDevtoolsShortcut || (isProtectedShortcut && !isEditableElement(event.target))) {
      blockEvent(event);
    }
  }, listenerOptions);

  protectImages();

  const observer = new MutationObserver(protectImages);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
};
